export default function (state = 0, action) {
    switch (action.type) {
        case 'CHANGE_FIRST_POP_COUNT':
            return action.payload;
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/config/allReducers/search/popCount/first.js